import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Contacts from "./pages/Contacts";
import Accreditations from "./pages/Accreditations";
import Awards from "./pages/Awards";
import OurInfrastructure from "./pages/OurInfrastructure";
import Register from "./pages/Register";
import Blogs from "./pages/Blogs";
import BlogsPost from "./pages/BlogsPost";
import TermsandConditions from "./pages/TermsandConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import PressAndMedia from "./pages/PressAndMedia";
import Testimonials from "./pages/Testimonials";
import VerifyCertificate from "./pages/VerifyCertificate";
import PhotoGallery from "./pages/PhotoGallery";
import VideoGallery from "./pages/VideoGallery";
import DynamicPage from "./pages/DynamicPage";
import NotFound from "./pages/NotFound";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/accreditations" element={<Accreditations />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/our-infrastructure" element={<OurInfrastructure />} />
          <Route path="/register" element={<Register />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogsPost />} />
          <Route path="/terms-and-conditions" element={<TermsandConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/press-and-media" element={<PressAndMedia />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/verify-certificate" element={<VerifyCertificate />} />
          <Route path="/verify-certificate/:number" element={<VerifyCertificate />} />
          <Route path="/verifications" element={<VerifyCertificate />} />
          <Route path="/verifications/:number" element={<VerifyCertificate />} />
          <Route path="/photo-gallery" element={<PhotoGallery />} />
          <Route path="/video-gallery" element={<VideoGallery />} />

          {/* CMS-managed pages (About Us pages, then course pages): matches only if no route above matched */}
          <Route path="/:slug" element={<DynamicPage />} />

          {/* Any unmatched multi-segment path */}
          <Route path="*" element={<NotFound />} />

      </Routes>
       </BrowserRouter>
  );
};

export default App;
